import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/pl/")({
  head: () => routeHead('AGAPE — Skaluj MŚP z AI i automatyzacją, bez rekrutacji', META_DESCRIPTIONS.home.pl, '/pl'),
  component: Index,
});
